// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__P7FSq","active":"NavigationItem_active__HBalJ"};